/* ***** ----------------------------------------------- ***** **
** ***** Social Share JS
** ***** ----------------------------------------------- ***** */

/* global jQuery, Main, TweenMax, Power2 */
(function($){
	'use strict';

	Main.modules.socialShare = function() {

		var $content = $('.l-content'),
			duration = 0.4,
			emailShareClass = '.js-social_share--email',
			facebookShareClass = '.js-social_share--facebook',
			googleShareClass = '.js-social_share--google',
			socialShareToggleClass = '.js-social_share_toggle',
			tumblrShareClass = '.js-social_share--tumblr',
			twitterTweetClass = '.js-social_share--twitter',
			popUpHeight = 350,
			popUpWidth = 600,
			popUpLeftPosition = (screen.width/2) - (popUpWidth/2),
			popUpTopPosition = (screen.height/2) - (popUpHeight/2),

			facebookShare = function() {

				$content.on('click', facebookShareClass, function() {

					var shareData = $(this).data('share'),
						url = shareData.url;

					window.open('http://www.facebook.com/sharer/sharer.php?' + jQuery.param({
						'u' : url
					}), 'Facebook', 'top=' + popUpTopPosition + ', left=' + popUpLeftPosition + ', width=' + popUpWidth + ', height=' + popUpHeight + ', resizable=no, scrollbars=no');

				});

			},

			twitterTweet =  function() {

				$content.on('click', twitterTweetClass, function() {

					var shareData = $(this).data('share'),
						url = shareData.url,
						title = shareData.title,
						via = shareData.via;

					window.open('https://twitter.com/intent/tweet?' + jQuery.param({
						'source' : 'webclient',
						'text' : title === null ? '' : title,
						'url' : url,
						'via' : via
					}), 'Twitter', 'top=' + popUpTopPosition + ', left=' + popUpLeftPosition + ', width=' + popUpWidth + ', height=' + popUpHeight + ', resizable=no, scrollbars=no');

				});

			},

			tumblrShare = function() {

				$content.on('click', tumblrShareClass, function() {

					var shareData = $(this).data('share'),
						url = shareData.url;

					window.open('https://www.tumblr.com/widgets/share/tool?' + jQuery.param({
						'url' : url,
						'posttype' : 'link'
					}), 'Tumblr', 'top=' + popUpTopPosition + ', left=' + popUpLeftPosition + ', width=' + popUpWidth + ', height=' + popUpHeight + ', resizable=no, scrollbars=no');

				});

			},

			googleShare = function() {

				$content.on('click', googleShareClass, function() {

					var shareData = $(this).data('share'),
						url = shareData.url;

					window.open('https://plus.google.com/share?' + jQuery.param({
						'url' : url
					}), 'Google', 'top=' + popUpTopPosition + ', left=' + popUpLeftPosition + ', width=' + popUpWidth + ', height=' + popUpHeight + ', resizable=no, scrollbars=no');

				});

			},

			emailShare = function() {

				$content.on('click', emailShareClass, function() {

					var shareData = $(this).data('share'),
						url = shareData.url,
						title = shareData.title,
						subjectPrefix = shareData.subjectPrefix,
						subject = subjectPrefix + ': ' + title,
						body = 'Check it out here: ' + url,
						emailUrl = 'mailto:test@test.com?body=' + body + '&subject=' + subject;

					window.open(emailUrl, '_self');

				});

			},

			socialShareToggle = function() {

				$content.on('click', socialShareToggleClass, function() {

					var $this = $(this),
						$socialShare = $this.parent(),
						$socialShareIcons = $this.next();

					if (!$socialShare.hasClass('o-social_share--is_active')) {

						// Show share icons with a slidedown animation if on post page
						if ($socialShare.hasClass('o-social_share--post')) {
							TweenMax.to($socialShareIcons, duration, {
								height: '30rem',
								ease: Power2.easeInOut
							});

						} else {
							// Show share icons with a slideout animation if on events archive page
							TweenMax.to($socialShareIcons, duration, {
								width: '25rem',
								ease: Power2.easeInOut
							});
						}

					} else {

						// Hide share icons with a slideup animation if on post page
						if ($socialShare.hasClass('o-social_share--post')) {
							TweenMax.to($socialShareIcons, duration, {
								height: '0',
								ease: Power2.easeInOut
							});
						} else {
							// Show share icons with a slideout animation if on events archive page
							TweenMax.to($socialShareIcons, duration, {
								width: '0',
								ease: Power2.easeInOut
							});
						}
						
					}

					$socialShare.toggleClass('o-social_share--is_active');

				});

			};

		return {
			init: function() {
				facebookShare();
				twitterTweet();
				tumblrShare();
				googleShare();
				emailShare();
				socialShareToggle();
			}
		}
		
	};

})(jQuery);